var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('em',[_vm._v("YOU CAN SEND BITCOIN WITH ANY CRYPTO WALLET INCLUDING:")]),_c('CCashAppInfo',{staticStyle:{"margin-bottom":"0.5em","margin-top":"0.5em"},on:{"buy":_vm.buy}}),_c('CPayPalInfo',{on:{"buy":_vm.buy}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }